import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    fetchApplicationSecurity,
    fetchApplicationSecurityAction
} from "../../actions/sub-domain";
import { fetchCustomerDomains } from "../../actions/customer";
import Pagination from "../Pagination/Pagination";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { API_URL } from "../../utils/constant";
import PieChart from "../../components/common/dashboard12/piechart.js";
import Select from "@mui/material/Select";
import { Link, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

const ApplicationSecurity = () => {
    let subdomains = useSelector(
        (state) => state?.subDomain?.response?.data?.domains
    );
    let totalData = useSelector((state) => state?.subDomain?.response?.data);

    let scanCompleted = useSelector((state) => state.subDomain?.scanCompleted);

    let scanDetails = useSelector(
        (state) => state?.subDomain?.garphData?.payload?.data
    );

    const vendorId = sessionStorage.getItem('vendorId');
    let totalCount = useSelector(
        (state) => state?.subDomain?.totalCount?.payload?.data
    );
    const [filterData, setfilterData] = useState("all");
    const [searchBy, setSearchBy] = useState("subDomainName");
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [severity, setSeverity] = useState("");

    const [page, setPage] = useState(1);
    const [PageSize, setPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [minExploitabilityScore, setMinExploitabilityScore] = useState("");
    const [totalItems, setTotalItems] = useState(0);
    const [isModal, setModal] = useState("");
    const [name, setName] = useState("");
    const [isModalTwo, setModalTwo] = useState("");
    const [cve, setCve] = useState([]);
    const [category, setCategory] = useState("all");
    const [forValue, setForValue] = useState("forever");
    const [lookalikeAppId, setLookalikeAppId] = useState([]);
    const [actionNote, setActionNote] = useState("");
    const [action, setAction] = useState("");
    const [selectedValue, setSelectedValue] = useState("pleaseSelect");
    const [limit, setLimit] = useState(10);
    const [domain, setDomain] = useState(""); // Add domain state
    const vendorName = sessionStorage.getItem('vendorName');
    const myRef = useRef(null);
    const dispatch = useDispatch();
    const { orgId } = useParams();
    const applicationSecurity = useSelector(
        (state) => state?.subDomain?.applicationSecurity
    );
    const customerDomains = useSelector(
        (state) => state?.customer?.customerDomains?.data || []
    );
    const auth = useSelector((state) => state?.auth?.user);
    const id = useSelector(state => {
        if (orgId) {
            return orgId;
        } else {
            return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
        }
    });
    const userPermission = useSelector(state => {
        return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
    });
    const client = useSelector(
        (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
    );

    const [expandedRows, setExpandedRows] = useState(new Set());
    const [expandedRemedies, setExpandedRemedies] = useState(new Set());
    const [expandedTechnical, setExpandedTechnical] = useState(new Set());
    const [showTechnicalModal, setShowTechnicalModal] = useState(false);
    const [technicalDetails, setTechnicalDetails] = useState(null);
    const [isRemediationModal, setRemediationModal] = useState("");
    const [remediationData, setRemediationData] = useState(null);

    const toggleDescription = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };

    const toggleRemedy = (index) => {
        const newExpandedRemedies = new Set(expandedRemedies);
        if (newExpandedRemedies.has(index)) {
            newExpandedRemedies.delete(index);
        } else {
            newExpandedRemedies.add(index);
        }
        setExpandedRemedies(newExpandedRemedies);
    };

    const toggleTechnical = (index) => {
        const newExpandedTechnical = new Set(expandedTechnical);
        if (newExpandedTechnical.has(index)) {
            newExpandedTechnical.delete(index);
        } else {
            newExpandedTechnical.add(index);
        }
        setExpandedTechnical(newExpandedTechnical);
    };

    const downloadFile = async () => {
        try {
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
            const response = await axios.get(
                `${API_URL}/domain-vulnerabilities/${id}/excel`,
                {
                    responseType: "blob",
                }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}-Application-security.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            // console.error removed
        }
    };

    useEffect(() => {
        fetchApplicationSecurity(id, page, dispatch, limit, category, domain, severity)
    }, [id, page, limit, category, domain, severity])

    useEffect(() => {
        setTotalItems(applicationSecurity?.totalItems)
    }, [applicationSecurity])

    useEffect(() => {
        // Fetch domains for the current client/organization
        if (id) {
            dispatch(fetchCustomerDomains(id));
        }
    }, [id, dispatch])

    // Fourth useEffect for fetching tech data
    const [selectedIds, setSelectedIds] = useState([]);
    const [multiCheckTrue, setMultiCheckTrue] = useState(false);

    const multicheck = (data) => {
        const allIds = data?.map((item) => item._id);
        if (selectedIds.length > 0 || selectedIds.length == 0) {
            setMultiCheckTrue(true);
            setSelectedIds(allIds);
        }
        if (multiCheckTrue == true) {
            setSelectedIds([]);
            setMultiCheckTrue(false);
        }
    };

    const singleClick = (id, data) => {
        setSelectedIds((prevSelectedIds) => {
            if (prevSelectedIds.includes(id)) {
                return prevSelectedIds.filter((selectedId) => selectedId !== id);
            } else {
                return [...prevSelectedIds, id];
            }
        });
        if (selectedIds.length > 10) {
            setMultiCheckTrue(true);
        } else {
            setMultiCheckTrue(false);
        }
    };

    const snooze = (_id, event, name) => {
        if (event == "markAsRemidiated") {
            const data = {
                action: "markAsRemidiated",
                ids: selectedIds == 0 ? [_id] : selectedIds,
                actionNote: "",
                for: "forever"
            };
            fetchApplicationSecurityAction(
                id,
                page,
                dispatch,
                limit,
                category,
                data,
                domain,
                severity
            );
            setSelectedValue("pleaseSelect");
            setActionNote("");
            setSelectedIds([]);
        }
    };

    const Unsnoozed = (_id) => {
        const data = {
            action: "resetAction",
            ids: selectedIds == 0 ? [_id] : selectedIds,
        };
        fetchApplicationSecurityAction(
            id,
            page,
            dispatch,
            limit,
            category,
            data,
            domain,
            severity
        );
        setSelectedIds([]);
    };

    const submit = () => {
        const data = {
            action: action,
            ids: selectedIds == 0 ? lookalikeAppId : selectedIds,
            actionNote: actionNote,
            for: forValue
        };
        fetchApplicationSecurityAction(
            id,
            page,
            dispatch,
            limit,
            category,
            data,
            domain,
            severity
        );
        setModalTwo("");
        setSelectedValue("pleaseSelect");
        setActionNote("");
        setSelectedIds([]);
    };

    const addModal = () => {
        setModalTwo("Form Wizard modal two");
    };

    const editRemediationModal = (row) => {
        setRemediationData(row);
        setRemediationModal("Remediation Modal");
    };

    let currentTableData = [];


    let clientName = "";

    if (JSON.parse(localStorage.getItem("OrgName"))) {
        if (sessionStorage.getItem('vendorId')) {
            clientName = sessionStorage.getItem('vendorName')
        } else {
            clientName = JSON.parse(localStorage.getItem("OrgName"));
        }
    }

    let mapData = applicationSecurity?.data;

    if (mapData && mapData.length > 0) {
        currentTableData = mapData;
    }

    // Tooltip rebuild is no longer needed in react-tooltip v5+

    const getSeverityBadgeStyle = (severity) => {
        switch (severity?.toLowerCase()) {
            case 'critical':
                return {
                    backgroundColor: '#fde9e9',
                    color: '#dc3545',
                    border: '1px solid #dc3545'
                };
            case 'high':
                return {
                    backgroundColor: '#fff4ec',
                    color: '#fd7e14',
                    border: '1px solid #fd7e14'
                };
            case 'medium':
                return {
                    backgroundColor: '#fff8e1',
                    color: '#ffc107',
                    border: '1px solid #ffc107'
                };
            case 'low':
                return {
                    backgroundColor: '#e8f5e9',
                    color: '#28a745',
                    border: '1px solid #28a745'
                };
            default:
                return {
                    backgroundColor: '#f8f9fa',
                    color: '#6c757d',
                    border: '1px solid #6c757d'
                };
        }
    };

    return (
        <>
            <div className="container-fluid">
                <AccessPage></AccessPage>
                <ReactTooltip className="reactTooltipClass" />
                <div className="block-header">
                    <div className="row clearfix w-100">
                        <div className="col-md-6 col-sm-12">
                            <h1 className="welcome-text">Application Security</h1>
                            <nav aria-label="breadcrumb" className="mt-1">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        {vendorId ? <>
                                            <Link to="/vendor"
                                                onClick={(() => {
                                                    sessionStorage.clear();
                                                })}
                                            >Vendor Assessment</Link>
                                        </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                                    </li>
                                    {
                                        vendorName ?
                                            <li
                                                className="breadcrumb-item active"
                                                aria-current="page"
                                                style={{ color: "white" }}
                                            >
                                                <Link to={`/dashboard/vendor/${vendorId}`}
                                                >{vendorName}</Link>
                                            </li> : ''
                                    }
                                    <li
                                        className="breadcrumb-item active"
                                        aria-current="page"
                                        style={{ color: "white" }}
                                    >
                                        Application Security
                                    </li>
                                </ol>
                                <br />
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadFile();
                                    }}
                                    href="/add-report"
                                    className="btn btn-sm btn-primary download-report"
                                    style={{ float: 'right' }}
                                >
                                    Download Details
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                {typeof scanCompleted !== "undefined" && !scanCompleted && (
                    <div className="card border-success">
                        <ScanMessage />
                    </div>
                )}

                <div className="row clearfix">
                    <div className="col-sm-12">
                        <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                                <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                                    <li className="nav-item">
                                        <a
                                            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                                                }`}
                                            onClick={() => {
                                                setCategory("all");
                                                setPage(1);
                                                setfilterData("all");
                                                setSearchBy("subDomainName");
                                                setSearch("");
                                                setSelectedIds([]);
                                                setSeverity('');
                                                setMinExploitabilityScore('');
                                            }}
                                        >
                                            Current
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                                                }`}
                                            onClick={() => {
                                                setCategory("risk-accepted");
                                                setPage(1);
                                                setfilterData("all");
                                                setSearchBy("subDomainName");
                                                setSearch("");
                                                setSelectedIds([]);
                                                setSeverity('');
                                                setMinExploitabilityScore('');
                                            }}
                                        >
                                            Risk Accepted
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                                                }`}
                                            onClick={() => {
                                                setCategory("false-positive");
                                                setPage(1);
                                                setfilterData("all");
                                                setSearchBy("subDomainName");
                                                setSearch("");
                                                setSelectedIds([]);
                                                setSeverity('');
                                                setMinExploitabilityScore('');
                                            }}
                                        >
                                            False Positive
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                                                }`}
                                            onClick={() => {
                                                setCategory("remidiated");
                                                setPage(1);
                                                setfilterData("all");
                                                setSearchBy("subDomainName");
                                                setSearch("");
                                                setSelectedIds([]);
                                                setSeverity('');
                                                setMinExploitabilityScore('');
                                            }}
                                        >
                                            Remediated
                                        </a>
                                    </li>
                                </ul>
                                <div className="card card_tableBox" ref={myRef}>
                                    <div className="header">
                                        <div className="body">
                                            <div className="d-flex justify-content-between align-items-center mb-2 mr-4">
                                                <div className="filterBox d-flex gap-2">
                                                    <select
                                                        className="custom-select custom-select-sm form-control form-control-sm mb-2"
                                                        placeholder="Select Domain"
                                                        value={domain}
                                                        onChange={(e) => {
                                                            setDomain(e.target.value);
                                                            setPage(1);
                                                        }}
                                                        style={{ width: "200px" }}
                                                    >
                                                        <option value="">All Domains</option>
                                                        {customerDomains?.domains?.map((domainItem, index) => (
                                                            <option key={index} value={domainItem}>
                                                                {domainItem}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <select
                                                        className="custom-select custom-select-sm form-control form-control-sm mb-2"
                                                        value={severity}
                                                        onChange={(e) => {
                                                            setSeverity(e.target.value);
                                                            setPage(1);
                                                        }}
                                                        style={{ width: "150px" }}
                                                    >
                                                        <option value="">All Severities</option>
                                                        <option value="critical">Critical</option>
                                                        <option value="high">High</option>
                                                        <option value="medium">Medium</option>
                                                        <option value="low">Low</option>
                                                    </select>
                                                </div>
                                                {selectedIds.length > 1 && userPermission && category === "all" && (
                                                    <Box sx={{ width: 160 }}>
                                                        <FormControl fullWidth>
                                                            <Select
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                value={selectedValue}
                                                                onChange={(event) => {
                                                                    setAction(event.target.value);
                                                                    snooze("", event.target.value);
                                                                }}
                                                            >
                                                                <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                                                                <MenuItem
                                                                    value="riskAccepted"
                                                                    onClick={() => {
                                                                        addModal();
                                                                    }}
                                                                >
                                                                    Risk Accepted
                                                                </MenuItem>
                                                                <MenuItem
                                                                    value="markAsFalsePositive"
                                                                    onClick={() => {
                                                                        addModal();
                                                                    }}
                                                                >
                                                                    False Positive
                                                                </MenuItem>
                                                                <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                )}
                                                {selectedIds.length > 1 && userPermission &&
                                                    (category == "false-positive" || category == "risk-accepted") && (
                                                        <button
                                                            className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                                            onClick={() => Unsnoozed("")}
                                                        >
                                                            Unsnooze
                                                        </button>
                                                    )}
                                            </div>
                                            {/* Horizontal scroll hint */}
                                            <div style={{ 
                                                fontSize: '12px', 
                                                color: '#6c757d', 
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-custom spacing5 mb-0" style={{ 
                                                    tableLayout: "fixed", 
                                                    width: "100%",
                                                    fontSize: "12px"
                                                }}>
                                                    <thead>
                                                        <tr>
                                                            {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                                                category === "risk-accepted" ||
                                                                category === "false-positive") && (
                                                                    <th style={{ width: "2%" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={
                                                                                selectedIds == 0 ? false : multiCheckTrue
                                                                            }
                                                                            onClick={() => {
                                                                                multicheck(currentTableData);
                                                                            }}
                                                                            className="checkUncheck"
                                                                        />
                                                                    </th>
                                                                )}
                                                            <th style={{ width: "8%" }}>Vulnerability</th>
                                                            <th style={{ width: "14%" }}>Host/IP</th>
                                                            <th style={{ width: "5%" }}>Severity</th>
                                                            <th style={{ width: "18%" }}>Description</th>
                                                            <th style={{ width: "12%" }}>Technical Details</th>
                                                            <th style={{ width: "15%" }}>Remediation</th>
                                                            {category !== "all" && <th style={{ width: "10%" }}>Action Note</th>}
                                                            <th style={{ width: "8%" }}>Created At</th>
                                                            <th style={{ width: "8%" }}>Updated At</th>
                                                            {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                                                                category === "risk-accepted" ||
                                                                category === "false-positive") && (
                                                                    <th style={{ width: "80" }}>Action</th>
                                                                )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentTableData?.map((res, index) => {
                                                            const severity = res?.vulnerability?.info?.severity ||
                                                                (res?.vulnerability?.hasSecureRedirect === false ? "medium" : "low");
                                                            const template = res?.template || "N/A";
                                                            const vulnType = res?.vulnerability?.type ||
                                                                (template === "http/insecure-redirects" ? "Insecure Redirect" : "Unknown");
                                                            const url = res?.url || "N/A";
                                                            const createdAt = new Date(res?.createdAt).toLocaleDateString();

                                                            return (
                                                                <tr key={index}>
                                                                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                                                        category === "risk-accepted" ||
                                                                        category === "false-positive") && (
                                                                            <td>
                                                                                <input
                                                                                    onClick={() =>
                                                                                        singleClick(
                                                                                            res?._id,
                                                                                            res?.subDomainName,
                                                                                            res?._id
                                                                                        )
                                                                                    }
                                                                                    checked={selectedIds?.includes(res?._id)}
                                                                                    type="checkbox"
                                                                                    className="checkUncheck"
                                                                                />
                                                                            </td>
                                                                        )}
                                                                    <td id="info" style={{
                                                                        maxWidth: "250px",
                                                                        width: "250px",
                                                                        wordWrap: "break-word",
                                                                        overflowWrap: "break-word",
                                                                        whiteSpace: "normal",
                                                                        paddingBottom: "16px"
                                                                    }}>
                                                                        <div style={{
                                                                            width: '100%',
                                                                            wordBreak: "break-word",
                                                                            overflowWrap: "break-word"
                                                                        }}>
                                                                            <strong style={{
                                                                                fontSize: '13px',
                                                                                wordBreak: "break-word",
                                                                                overflowWrap: "break-word",
                                                                                display: 'block',
                                                                                lineHeight: '1.3',
                                                                                width: '100%'
                                                                            }}>
                                                                                {expandedRows.has(index) ?
                                                                                    res?.vulnerability?.info?.name || 'N/A' :
                                                                                    (res?.vulnerability?.info?.name || 'N/A').length > 30 ?
                                                                                        `${(res?.vulnerability?.info?.name || 'N/A').substring(0, 30)}...` :
                                                                                        res?.vulnerability?.info?.name || 'N/A'
                                                                                }
                                                                            </strong>
                                                                            {res?.vulnerability?.info?.name === "HTTP Missing Security Headers" && (
                                                                                <div style={{
                                                                                    wordBreak: "break-word",
                                                                                    overflowWrap: "break-word",
                                                                                    fontSize: '12px',
                                                                                    color: '#666',
                                                                                    marginTop: '4px'
                                                                                }}>
                                                                                    {` (${res?.vulnerability["matcher-name"]})`}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        {(res?.vulnerability?.info?.name || 'N/A').length > 30 && (
                                                                            <div className="mt-1 mb-2" style={{ width: '100%', wordBreak: 'break-word' }}>
                                                                                <span
                                                                                    className="text-primary"
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '11px',
                                                                                        textDecoration: 'underline',
                                                                                        display: 'inline-block',
                                                                                        maxWidth: '100%',
                                                                                        wordWrap: 'break-word',
                                                                                        overflowWrap: 'break-word'
                                                                                    }}
                                                                                    onClick={() => toggleDescription(index)}
                                                                                >
                                                                                    {expandedRows.has(index) ? 'Show less' : 'Show more'}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </td>

                                                                    <td style={{
                                                                        maxWidth: "400px",
                                                                        width: "400px",
                                                                        wordWrap: "break-word",
                                                                        overflowWrap: "break-word",
                                                                        whiteSpace: "normal"
                                                                    }}>
                                                                        <div style={{ width: "100%" }}>
                                                                            <div className="font-weight-bold" style={{
                                                                                fontSize: '13px',
                                                                                wordBreak: "normal",
                                                                                overflowWrap: "normal",
                                                                                lineHeight: "1.3"
                                                                            }}>
                                                                                {res?.vulnerability?.host || res?.host || 'N/A'}
                                                                            </div>
                                                                            {res?.vulnerability?.ip && (
                                                                                <small className="text-muted d-block" style={{
                                                                                    fontSize: '11px',
                                                                                    wordBreak: "normal",
                                                                                    overflowWrap: "normal"
                                                                                }}>
                                                                                    IP: {res.vulnerability.ip}
                                                                                </small>
                                                                            )}
                                                                            {res?.vulnerability?.port && (
                                                                                <small className="text-muted d-block" style={{
                                                                                    fontSize: '11px',
                                                                                    wordBreak: "normal",
                                                                                    overflowWrap: "normal"
                                                                                }}>
                                                                                    Port: {res.vulnerability.port}
                                                                                </small>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            style={{
                                                                                ...getSeverityBadgeStyle(severity),
                                                                                padding: '4px 8px',
                                                                                borderRadius: '4px',
                                                                                fontSize: '12px',
                                                                                fontWeight: '500',
                                                                                display: 'inline-block',
                                                                                textTransform: 'capitalize'
                                                                            }}
                                                                        >
                                                                            {severity || 'N/A'}
                                                                        </span>
                                                                    </td>
                                                                    <td style={{
                                                                        maxWidth: "500px",
                                                                        wordWrap: "break-word",
                                                                        lineHeight: "1.5",
                                                                        padding: "12px 16px"
                                                                    }}>
                                                                        {res?.vulnerability?.info?.description ? (
                                                                            <div style={{
                                                                                backgroundColor: expandedRows.has(index) ? '#f8f9fa' : 'transparent',
                                                                                padding: expandedRows.has(index) ? '12px' : '0',
                                                                                borderRadius: expandedRows.has(index) ? '8px' : '0',
                                                                                border: expandedRows.has(index) ? '1px solid #e9ecef' : 'none',
                                                                                transition: 'all 0.3s ease',
                                                                                width: '100%',
                                                                                overflow: 'hidden'
                                                                            }}>
                                                                                <div style={{
                                                                                    fontSize: '14px',
                                                                                    color: '#495057',
                                                                                    marginBottom: expandedRows.has(index) ? '8px' : '0',
                                                                                    wordWrap: 'break-word',
                                                                                    overflowWrap: 'break-word',
                                                                                    whiteSpace: expandedRows.has(index) ? 'normal' : 'nowrap',
                                                                                    ...(expandedRows.has(index) ? {
                                                                                        whiteSpace: 'pre-wrap',
                                                                                        wordBreak: 'break-word'
                                                                                    } : {
                                                                                        display: '-webkit-box',
                                                                                        WebkitLineClamp: 5,
                                                                                        WebkitBoxOrient: 'vertical',
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        lineHeight: '1.4',
                                                                                        maxHeight: 'calc(1.4em * 5)'
                                                                                    })
                                                                                }}>
                                                                                    {res?.vulnerability?.info?.description}
                                                                                </div>
                                                                                {res?.vulnerability?.info?.tags && res.vulnerability.info.tags.length > 0 && (
                                                                                    <div className="mt-2">
                                                                                        <small className="text-muted d-block mb-1">Tags:</small>
                                                                                        <div className="d-flex flex-wrap gap-1">
                                                                                            {res?.vulnerability?.info?.tags.map((tag, tagIndex) => (
                                                                                                <span key={tagIndex} className="badge bg-light text-dark" style={{ fontSize: '10px' }}>
                                                                                                    {tag}
                                                                                                </span>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                <span
                                                                                    className="text-primary"
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '13px',
                                                                                        fontWeight: '500',
                                                                                        textDecoration: 'none',
                                                                                        padding: '4px 8px',
                                                                                        borderRadius: '4px',
                                                                                        backgroundColor: '#e3f2fd',
                                                                                        color: '#1976d2',
                                                                                        transition: 'all 0.2s ease',
                                                                                        display: 'inline-block',
                                                                                        marginTop: '4px'
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.target.style.backgroundColor = '#bbdefb';
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.target.style.backgroundColor = '#e3f2fd';
                                                                                    }}
                                                                                    onClick={() => toggleDescription(index)}
                                                                                >
                                                                                    {expandedRows.has(index) ? 'Show less' : 'Show more'}
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            <span style={{
                                                                                color: '#6c757d',
                                                                                fontStyle: 'italic',
                                                                                fontSize: '14px'
                                                                            }}>
                                                                                N/A
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td style={{
                                                                        maxWidth: "400px",
                                                                        wordWrap: "break-word",
                                                                        lineHeight: "1.5",
                                                                        padding: "12px 16px"
                                                                    }}>
                                                                        <div>
                                                                            {res?.vulnerability?.matched_at && (
                                                                                <div className="mb-2">
                                                                                    <small className="text-muted d-block">Matched URL:</small>
                                                                                    <code style={{ fontSize: '11px', wordBreak: 'break-all' }}>
                                                                                        {res.vulnerability.matched_at}
                                                                                    </code>
                                                                                </div>
                                                                            )}
                                                                            {res?.vulnerability?.timestamp && (
                                                                                <div className="mb-2">
                                                                                    <small className="text-muted d-block">Detected:</small>
                                                                                    <div style={{ fontSize: '12px' }}>
                                                                                        {new Date(res.vulnerability.timestamp).toLocaleString()}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {res?.vulnerability?.scheme && (
                                                                                <div className="mb-2">
                                                                                    <small className="text-muted d-block">Protocol:</small>
                                                                                    <span className="badge bg-info" style={{ fontSize: '10px' }}>
                                                                                        {res.vulnerability.scheme.toUpperCase()}
                                                                                    </span>
                                                                                </div>
                                                                            )}

                                                                            {/* Technical Details Button */}
                                                                            {(res?.vulnerability?.["curl-command"] || res?.vulnerability?.request || res?.vulnerability?.response) && (
                                                                                <div className="mt-2">
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-info"
                                                                                        style={{ fontSize: '11px', padding: '4px 8px' }}
                                                                                        onClick={() => {
                                                                                            setTechnicalDetails({
                                                                                                curl: res?.vulnerability?.["curl-command"],
                                                                                                request: res?.vulnerability?.request,
                                                                                                response: res?.vulnerability?.response,
                                                                                                matchedAt: res?.vulnerability?.matched_at,
                                                                                                timestamp: res?.vulnerability?.timestamp,
                                                                                                scheme: res?.vulnerability?.scheme,
                                                                                                ip: res?.vulnerability?.ip,
                                                                                                port: res?.vulnerability?.port
                                                                                            });
                                                                                            setShowTechnicalModal(true);
                                                                                        }}
                                                                                    >
                                                                                        <i className="fas fa-cogs me-1"></i>
                                                                                        Show Details
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="" style={{
                                                                        maxWidth: "450px",
                                                                        wordWrap: "break-word",
                                                                        lineHeight: "1.5",
                                                                        padding: "12px 16px"
                                                                    }}>
                                                                        <div
                                                                            onClick={() =>
                                                                                res?.applicationSecurityRemedies?.remedy &&
                                                                                editRemediationModal(res?.applicationSecurityRemedies)
                                                                            }
                                                                            style={{
                                                                                cursor:
                                                                                    res?.applicationSecurityRemedies?.remedy
                                                                                        ? "pointer"
                                                                                        : "auto",
                                                                            }}
                                                                        >
                                                                            {res?.applicationSecurityRemedies?.remedy
                                                                                ? <Link to="#">Remediation (Details)</Link>
                                                                                : "N/A"}
                                                                        </div>
                                                                    </td>
                                                                    {category !== "all" && <td style={{ whiteSpace: "unset" }}>{res?.actionNote ? res.actionNote : "N/A"}</td>}
                                                                    <td>{res?.createdAt?.split('T')[0]}</td>
                                                                    <td>{res?.updatedAt?.split('T')[0]}</td>
                                                                    {res?.remediationPending === true ? (
                                                                        <td>Retest in progress</td>
                                                                    ) : (
                                                                        <>
                                                                            {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                                                                <td>
                                                                                    <Box sx={{ width: 160 }}>
                                                                                        <FormControl fullWidth>
                                                                                            <Select
                                                                                                labelId="demo-simple-select-label"
                                                                                                id="demo-simple-select"
                                                                                                value={selectedValue}
                                                                                                onChange={(event) => {
                                                                                                    setAction(event.target.value);
                                                                                                    snooze(
                                                                                                        res?._id,
                                                                                                        event.target.value,
                                                                                                        res?.subDomainName
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <MenuItem value="pleaseSelect">
                                                                                                    Snooze Options
                                                                                                </MenuItem>
                                                                                                <MenuItem
                                                                                                    value="riskAccepted"
                                                                                                    onClick={() => {
                                                                                                        addModal();
                                                                                                        setName(res?.subDomainName);
                                                                                                        setLookalikeAppId([res?._id]);
                                                                                                    }}
                                                                                                >
                                                                                                    Risk Accepted
                                                                                                </MenuItem>
                                                                                                <MenuItem
                                                                                                    value="markAsFalsePositive"
                                                                                                    onClick={() => {
                                                                                                        addModal();
                                                                                                        setName(res?.subDomainName);
                                                                                                        setLookalikeAppId([res?._id]);
                                                                                                    }}
                                                                                                >
                                                                                                    False Positive
                                                                                                </MenuItem>
                                                                                                <MenuItem value="markAsRemidiated">
                                                                                                    Remediated
                                                                                                </MenuItem>
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                    </Box>
                                                                                </td>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {auth?.accessLevel != "Threat Analyst" && (category === "risk-accepted" ||
                                                                        category === "false-positive") && (
                                                                            <td>
                                                                                <button
                                                                                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                                                                    onClick={() =>
                                                                                        Unsnoozed(
                                                                                            res?._id,
                                                                                            res?.subDomainName,
                                                                                            res?._id
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Unsnooze
                                                                                </button>
                                                                            </td>
                                                                        )}
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-content-center">
                                                <div className="dataTables_paginate">
                                                    {totalItems > 0 && (
                                                        <Pagination
                                                            className="pagination-bar"
                                                            currentPage={page}
                                                            totalCount={totalItems}
                                                            pageSize={limit}
                                                            onPageChange={(page) => {
                                                                setPage(page);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                {totalItems > 10 && (
                                                    <select
                                                        value={limit}
                                                        onChange={(e) => {
                                                            setLimit(e.target.value)
                                                        }}
                                                        className="form-control limitSelectBox"
                                                    >
                                                        <option value={10}>10 per page</option>
                                                        <option value={25}>25 per page</option>
                                                        <option value={50}>50 per page</option>
                                                        <option value={100}>100 per page</option>
                                                    </select>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Technical Details Modal */}
                {showTechnicalModal && technicalDetails && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header bg-info text-white">
                                    <h5 className="modal-title">
                                        <i className="fas fa-cogs me-2"></i>
                                        Technical Details
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={() => {
                                            setShowTechnicalModal(false);
                                            setTechnicalDetails(null);
                                        }}
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card mb-3">
                                                <div className="card-header bg-light">
                                                    <h6 className="mb-0">Connection Details</h6>
                                                </div>
                                                <div className="card-body">
                                                    {technicalDetails.matchedAt && (
                                                        <div className="mb-2">
                                                            <small className="text-muted d-block">Matched URL:</small>
                                                            <code className="text-break" style={{ fontSize: '12px' }}>
                                                                {technicalDetails.matchedAt}
                                                            </code>
                                                        </div>
                                                    )}
                                                    {technicalDetails.ip && (
                                                        <div className="mb-2">
                                                            <small className="text-muted d-block">IP Address:</small>
                                                            <strong>{technicalDetails.ip}</strong>
                                                        </div>
                                                    )}
                                                    {technicalDetails.port && (
                                                        <div className="mb-2">
                                                            <small className="text-muted d-block">Port:</small>
                                                            <strong>{technicalDetails.port}</strong>
                                                        </div>
                                                    )}
                                                    {technicalDetails.scheme && (
                                                        <div className="mb-2">
                                                            <small className="text-muted d-block">Protocol:</small>
                                                            <span className="badge bg-info">{technicalDetails.scheme.toUpperCase()}</span>
                                                        </div>
                                                    )}
                                                    {technicalDetails.timestamp && (
                                                        <div>
                                                            <small className="text-muted d-block">Detection Time:</small>
                                                            <strong>{new Date(technicalDetails.timestamp).toLocaleString()}</strong>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {technicalDetails.curl && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-light">
                                                        <h6 className="mb-0">Curl Command</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <code style={{ fontSize: '11px', wordBreak: 'break-all', backgroundColor: '#f8f9fa', padding: '8px', borderRadius: '4px', display: 'block' }}>
                                                            {technicalDetails.curl}
                                                        </code>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {technicalDetails.request && (
                                        <div className="card mb-3">
                                            <div className="card-header bg-light">
                                                <h6 className="mb-0">HTTP Request</h6>
                                            </div>
                                            <div className="card-body">
                                                <code style={{ fontSize: '11px', wordBreak: 'break-all', backgroundColor: '#f8f9fa', padding: '8px', borderRadius: '4px', display: 'block', whiteSpace: 'pre-wrap' }}>
                                                    {technicalDetails.request}
                                                </code>
                                            </div>
                                        </div>
                                    )}

                                    {technicalDetails.response && (
                                        <div className="card mb-3">
                                            <div className="card-header bg-light">
                                                <h6 className="mb-0">HTTP Response</h6>
                                            </div>
                                            <div className="card-body">
                                                <code style={{ fontSize: '11px', wordBreak: 'break-all', backgroundColor: '#f8f9fa', padding: '8px', borderRadius: '4px', display: 'block', whiteSpace: 'pre-wrap' }}>
                                                    {technicalDetails.response}
                                                </code>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowTechnicalModal(false);
                                            setTechnicalDetails(null);
                                        }}
                                    >
                                        Close
                                    </button>
                                    {technicalDetails.curl && (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => {
                                                navigator.clipboard.writeText(technicalDetails.curl);
                                            }}
                                        >
                                            <i className="fas fa-copy me-2"></i>
                                            Copy Curl Command
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div
                    className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""
                        }`}
                >
                    <div className="modal-dialog modal-lg" id="clientModal">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    {action == "markAsFalsePositive"
                                        ? "Mark As False Positive"
                                        : "Risk Accepted"}
                                </h5>
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => {
                                        setModalTwo("");
                                        setActionNote("");
                                    }}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body pricing_page modal_mob">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="card">
                                        <div className="row clearfix">
                                            <div className="col-md-12">
                                                <label className="col-lg-6 col-md-12">Snooze for</label>
                                                <div className="form-group ol-lg-12 col-md-12">
                                                    <select
                                                        className="custom-select custom-select-sm form-control form-control-sm"
                                                        onChange={(e) => setForValue(e.target.value)}
                                                    >
                                                        <option value="forever">Forever</option>
                                                        <option value="3 months">3 Months</option>
                                                        <option value="6 months">6 Months</option>
                                                        <option value="12 months">12 Months</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="col-lg-12 col-md-12">Detail</label>
                                                <div className="form-group col-lg-12 col-md-12">
                                                    <textarea
                                                        onChange={(e) => setActionNote(e.target.value)}
                                                        value={actionNote}
                                                        className="form-control"
                                                        rows="3"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div
                                                className="col-lg-12 col-md-12"
                                                style={{ marginRight: "28px" }}
                                            >
                                                <button
                                                    type="button"
                                                    style={{ color: "black", fontWeight: "bold" }}
                                                    onClick={submit}
                                                    className="btn btn-round btn-primary mr-1 pull-right"
                                                >
                                                    Submit
                                                </button>
                                                &nbsp;&nbsp;
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setModalTwo("");
                                                        setActionNote("");
                                                    }}
                                                    className="btn btn-round btn-default pull-right"
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Remediation Details Modal */}
                <div
                    className={`modal fade Form-Wizard-modal ${isRemediationModal === "Remediation Modal" ? "d-block show" : ""
                        }`}
                >
                    <div className="modal-dialog modal-lg" id="remediationModal">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="remediationModalLabel">
                                    Remediation Details
                                </h5>
                                <button
                                    type="button"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setRemediationModal("")}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body pricing_page">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="card">
                                        <div className="row clearfix">
                                            <div className="col-lg-12 col-md-12">
                                                {remediationData && (
                                                    <div>
                                                        {remediationData?.issue_name && (
                                                            <div className="mb-4">
                                                                <h6 className="text-primary">Issue Name:</h6>
                                                                <div className="alert alert-info" style={{ fontSize: '14px' }}>
                                                                    <strong>{remediationData.issue_name}</strong>
                                                                </div>
                                                            </div>
                                                        )}
                                                        
                                                        {remediationData?.remedy && (
                                                            <div className="mb-4">
                                                                <h6 className="text-success">Remediation Steps:</h6>
                                                                <div 
                                                                    className="alert alert-light border" 
                                                                    style={{ 
                                                                        fontSize: '14px',
                                                                        lineHeight: '1.6',
                                                                        whiteSpace: 'pre-wrap',
                                                                        wordWrap: 'break-word',
                                                                        backgroundColor: '#f8f9fa',
                                                                        borderLeft: '4px solid #28a745',
                                                                        padding: '15px'
                                                                    }}
                                                                >
                                                                    {remediationData.remedy}
                                                                </div>
                                                            </div>
                                                        )}
                                                        
                                                        <div className="text-center mt-4">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm mr-2"
                                                                onClick={() => {
                                                                    const copyText = `${remediationData?.issue_name ? `Issue: ${remediationData.issue_name}\n\n` : ''}Remediation:\n${remediationData?.remedy || 'N/A'}`;
                                                                    navigator.clipboard.writeText(copyText);
                                                                }}
                                                            >
                                                                <i className="fas fa-copy me-1"></i>
                                                                Copy Details
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary btn-sm"
                                                                onClick={() => setRemediationModal("")}
                                                            >
                                                                Close
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ApplicationSecurity;
